export default "__VITE_ASSET__BsZMdwyJ__"